/**
 * Shared client-side list search: word-start / prefix matching.
 * Avoids mid-token hits (e.g. "am" matching "Benjamin").
 */

function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function sanitizeSearchTerm(raw) {
  return String(raw ?? '').trim();
}

/**
 * True when `value` starts with `query`, or a word in `value` starts with `query`.
 */
export function matchesWordStart(value, query) {
  const q = sanitizeSearchTerm(query).toLowerCase();
  if (!q) return true;
  const text = String(value ?? '').toLowerCase();
  if (!text) return false;
  if (text.startsWith(q)) return true;
  // Start of string or after common separators (space, comma, hyphen, slash, @, ., (, _)
  const re = new RegExp(`(?:^|[\\s,./\\-_@(+])${escapeRegExp(q)}`);
  return re.test(text);
}

/** True if any provided value matches word-start search. */
export function matchesWordStartAny(values, query) {
  const q = sanitizeSearchTerm(query);
  if (!q) return true;
  return (Array.isArray(values) ? values : [values]).some((value) => matchesWordStart(value, q));
}
